module.exports = __webpack_public_path__ + "img/face4.df02fd1f.jpg";